module.exports = __webpack_public_path__ + "img/invite-icon.6b889d3f.png";